import styled from "styled-components";
import { spacing } from "@magicbi/ui-library";

export const GateState = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: ${spacing[2]};
  width: 100%;
  min-height: 12rem;
  padding: ${spacing[6]} ${spacing[4]};
  color: ${({ theme }) => theme.colors.text.secondary};
`;
